import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import Iconify from '../../../components/iconify';

// ----------------------------------------------------------------------

const navConfig = [
  {
    title: 'Penagihan',
    icon: <Iconify icon={'ant-design:environment-filled'} />,
    submenu: [
      {
        title: 'Monitoring',
        path: '/mis/penagihan/monitoring',
        icon: <FiberManualRecordIcon sx={{ fontSize: 6 }} />,
      },
      {
        title: 'Laporan By Petugas',
        path: '/mis/penagihan/laporan-by-petugas',
        icon: <FiberManualRecordIcon sx={{ fontSize: 6 }} />,
      },
      {
        title: 'Tracking',
        path: '/mis/penagihan/tracking',
        icon: <FiberManualRecordIcon sx={{ fontSize: 6 }} />,
      },
    ],
  },
  {
    title: 'Penagihan Eksternal',
    path: '/mis/penagihan-eksternal',
    icon:  <Iconify icon={'ant-design:file-text-filled'} />,
  },
];

export default navConfig;
